var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "articleModal",
          attrs: {
            visible: _vm.visible,
            title: "日志详情",
            top: "100px",
            width: "50vw",
            "destroy-on-close": "",
            modal: false,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            [
              _c("el-form-item", { attrs: { label: "日志标题：" } }, [
                _vm._v(_vm._s(_vm.details.title)),
              ]),
              _vm._v(" "),
              _c("el-form-item", { attrs: { label: "日志时间：" } }, [
                _vm._v(_vm._s(_vm.details.createTime)),
              ]),
              _vm._v(" "),
              _c("el-form-item", { attrs: { label: "详细信息：" } }, [
                _vm._v(_vm._s(_vm.details.expDetail)),
              ]),
              _vm._v(" "),
              _c("el-form-item", [
                _c(
                  "div",
                  { staticStyle: { "text-align": "right" } },
                  [
                    _c(
                      "el-button",
                      { attrs: { type: "link" }, on: { click: _vm.closeEdit } },
                      [_vm._v("关闭")]
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }